import React from "react";
import clsx from "clsx";

const STAR_COUNT = 5;
const STAR_PATH = "M12 3.4l2.6 5.5 6 .8-4.4 4.2 1.1 6-5.3-3-5.3 3 1.1-6L3.4 9.7l6-.8L12 3.4Z";

export type StarRatingProps = {
  rating: number;
  className?: string;
  starClassName?: string;
  emptyStarClassName?: string;
};

const StarRating: React.FC<StarRatingProps> = ({
  rating,
  className,
  starClassName,
  emptyStarClassName,
}) => {
  const filledStars = Math.max(0, Math.min(STAR_COUNT, Math.round(rating)));

  return (
    <span
      role="img"
      aria-label={`${rating.toFixed(1)} out of ${STAR_COUNT} stars`}
      className={clsx("inline-flex items-center gap-0.5", className)}
    >
      {Array.from({ length: STAR_COUNT }, (_unused, index) => (
        <svg
          key={index}
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
          className={clsx(
            "h-4 w-4",
            index < filledStars ? clsx("text-[#F59E0B]", starClassName) : clsx("text-myteengig-border", emptyStarClassName),
          )}
        >
          <path d={STAR_PATH} fill="currentColor" />
        </svg>
      ))}
    </span>
  );
};

export default StarRating;
